<template>
    <bottom-sheet v-model="shows" title="미팅현황" fullscreen persistent max-width="1080" width="100%">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents">
            <div class="text-center mb-20 mb-lg-40">
                <h3 class="tit mb-8 mb-lg-16">미팅현황</h3>
                <p class="page-text--lg grey-6--text">미팅현황을 확인해보세요.</p>
            </div>
            <h5 class="page-text--lg mb-8 mb-lg-16">{{ meeting?.title }}</h5>
            <v-card-text>
                <v-sheet>
                    <meeting-status-item v-for="{ application, schedule } in items" :key="application?._id" :value="schedule" v-bind="{ meeting, application, schedulesAvailable }" class="mb-30" @search="init" />
                </v-sheet>
            </v-card-text>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import { initMeeting, initMeetingSchedule } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import MeetingStatusItem from "./meeting-status-item.vue";

export default {
    components: {
        BottomSheet,
        MeetingStatusItem,
    },
    props: {
        value: { type: Object, default: initMeeting },
    },
    data: () => ({
        meeting: initMeeting(),
        schedules: [],

        shows: false,
        loading: false,
    }),
    computed: {
        items() {
            return (this.meeting?.applications || [])
                .map((application) => {
                    let schedule = this.schedules.find(({ _application }) => _application == application._id);
                    if (!schedule) {
                        schedule = initMeetingSchedule({ ...application, _meeting: this.meeting?._id, _application: application._id });
                        delete schedule._id;
                    }
                    return { application, schedule };
                })
                .sort((a, b) => {
                    let aCreatedAt = a?.schedule?.createdAt;
                    let bCreatedAt = b?.schedule?.createdAt;

                    if (!aCreatedAt && !bCreatedAt) return 0;
                    else if (!aCreatedAt && bCreatedAt) return 1;
                    else if (aCreatedAt && !bCreatedAt) return -1;

                    if (dayjs(aCreatedAt).isAfter(bCreatedAt)) return 1;
                    else return -1;
                });
        },
        schedulesAvailable() {
            return this.meeting?.schedulesAvailable || [];
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows(shows) {
            if (shows) this.init();
            else this.$emit("input", this.meeting);
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                const { meeting } = await api.v1.company.meetings.get({ _id: this.value?._id });
                this.meeting = meeting;

                const { schedules } = await api.v1.company.meetings.schedules.gets({ _meeting: this.value?._id });
                this.schedules = schedules;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
